import type { ComponentPropsWithoutRef } from 'react';

type Props = Omit<ComponentPropsWithoutRef<'svg'>, 'xmlns' | 'viewBox' | 'className'>;

// https://thenounproject.com/term/armor/52022/
// armor by Jetro Cabau Quirós from the Noun Project
const Icon = (props: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80" className="stroke icon" {...props}>
    <path
      d="M75.25,23C65.75,19.75,59,26.5,59,26.5S56.75,35,50,35s-8.5-8.5-8.5-8.5s-6.75-6.25-17-2S14,38.001,14,38.001l12.5,7.249V73.5  c0,0,8.25,9,23.5,9s23.5-9,23.5-9V44.25l10.941-6.249C84.441,38.001,84.75,26.25,75.25,23z"
      fill="none"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Icon;
